import { mapGetters } from "vuex";

import { BackorderService, ErrorLogService, GridUtil } from "@/services";

import { formatDateTime, stringHelper } from "@/components/mixins/";

import { LoadingSpinner, OrderDetailsLink, PartDetailsLink } from "@/components";
import DnTable from "@/components/Elements/DnTable/DnTable.vue";

export default {
    components: {
        LoadingSpinner,
        OrderDetailsLink,
        PartDetailsLink,
        DnTable,
    },
    mixins: [stringHelper, formatDateTime],
    props: {
        documentNumber: {
            type: String,
            default: "",
        },
        partNumber: {
            type: String,
            default: "",
        },
        dealerCodes: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        BackorderResultsColumns: [
            { key: "OrderNumber", label: "Order #" },
            { key: "PurchaseOrderNumber", label : "PO #" },
            { key: "OemPartCode", label: "Part #" },
            { key: "EstimatedVendorShipDate", label: "Estimated Ship Date" },
            { key: "TotalQuantityOrdered", label: "Qty" },
            { key: "TotalQuantityBackordered", label: "Qty Backordered" },
            { key: "OrderType", label: "Order Type" },
            { key: "OrderCreatedDate", label: "Order Date" },
        ],
        isBackOrdersLoading: true,
        backorders: [],
    }),
    computed: {
        ...mapGetters(["getContentItem", "activeAccountId", "user", "audienceIds"]),
        SearchKeyword() {
            return this.documentNumber ? this.documentNumber : this.partNumber;
        },
    },
    mounted() {
        this.backorderSearch();
        this.BackorderResultsColumns = GridUtil.localizeColumnLabels(this.BackorderResultsColumns, this.getContentItem);
    },
    methods: {
        async backorderSearch() {
            try {
                this.backorders = [];
                this.isBackOrdersLoading = true;

                const req = {
                    accountId: this.activeAccountId,
                    userId: this.user.UserId,
                    partNumber: this.partNumber,
                    documentNumber: this.documentNumber,
                    dealerCodes: this.dealerCodes,
                    userAudiences: this.audienceIds
                };

                const response = await BackorderService.searchBackOrdersByDocumentOrPart(req);

                this.backorders = response.data;
            } catch (err) {
                ErrorLogService.LogException(err);
            } finally {
                this.isBackOrdersLoading = false;
            }
        },
    },
};
